import { ReactNode, ReactElement } from 'react';
import clsx from 'clsx';

interface TokenAssetListProps {
  children: ReactNode;
  className?: string;
}

function TokenAssetList({
  children,
  className,
}: TokenAssetListProps): ReactElement {
  return (
    <ul
      className={clsx(
        'list-none bg-black rounded-medium text-white divide-white divide-y divide-solid divide-opacity-20 shadow-default',
        className
      )}
    >
      {children}
    </ul>
  );
}

export default TokenAssetList;
